import React, { createContext, useState, useContext } from 'react';
import trTranslations from './locales/tr.json';
import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';

const LanguageContext = createContext();

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Tarayıcının dilini kontrol et veya localStorage'dan al
    const saved = localStorage.getItem('language');
    if (saved) return saved;

    const browserLang = navigator.language.split('-')[0];
    if (['tr', 'en', 'de'].includes(browserLang)) {
      return browserLang;
    }
    return 'tr'; // Varsayılan dil
  });

  const translations = {
    tr: trTranslations,
    en: enTranslations,
    de: deTranslations,
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];

    for (const k of keys) {
      value = value?.[k];
    }

    return value || key;
  };

  const changeLanguage = (lang) => {
    if (['tr', 'en', 'de'].includes(lang)) {
      setLanguage(lang);
      localStorage.setItem('language', lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ t, language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
